module.exports = __webpack_public_path__ + "static/media/booker.602126a3.jpg";